define(function (require) {
    var $ = require("jquery");
    var dataLayerService = require("@modules/services/dataLayerService");
    var $querystring = require("querystring");

    require("jqueryOutsideEvents");

    var loadedQuerystring = $querystring.parse();
    var searchFilterId = "#filterCollapse";
    var loadedSearchTerm = loadedQuerystring["Term"] || loadedQuerystring["term"];
    var knowledgeCenterUrl = window.scan && window.scan.siteSearch && window.scan.siteSearch.knowledgeCenterPageUrl;
    var searchPageUrl = window.scan && window.scan.siteSearch && window.scan.siteSearch.searchPageUrl;
    var siteLanguage = document.documentElement.lang.toLowerCase();
    var minSearchLength = siteLanguage === "ko" || siteLanguage === "zh" ? 2 : 3;
    var isKnowledgeCenter = window.location.pathname.toLowerCase().includes("/knowledge-center");
    var isMemberPortal = window.location.pathname.toLowerCase().includes("/members/account");
    var $heroForm = $("form[name=search-form]");
    var $audienceButtons = $("button.filter-button.for-search");
    var currentSearchTerm;

    var searchAudienceButtonClicked = function () {
        var returnString = "";

        if (arguments.length > 0) {
            // called as an event handler
            if ($(this).attr("aria-selected") === "true") {
                $(this).attr("aria-selected", "");
            } else {
                $(this).attr("aria-selected", "true");
            }
        }

        // set the audience form field value
        $audienceButtons.each(function (index, item) {
            if ($(item).attr("aria-selected") === "true") {
                if (returnString.length > 0) {
                    returnString += "|";
                }
                returnString += $(item).val();
            }
        });
        $("input[name=Audience]").val(returnString);
        $heroForm.attr("action", $heroForm.attr("action") + searchFilterId);
    };

    var headerFormInit = function () {
        var $headerForm = $(".header .search-holder");
        var $headerSearchInput = $headerForm.find(".search-input");
        var $headerSearchFocusContainer = $(".search-focus-container");

        $("<button/>", { class: "btn-link cancel", text: "Cancel", type: "button" }).appendTo(".header-portal .search-input-wrapper");

        var $headerSearchCloseBtn = $(".search .search-cancel, .header-portal .search-focus-container .cancel");

        var focusOnThis = function (cssSelector) {
            // focus on next item
            if ($(".page").hasClass("desktop")) {
                setTimeout(function () {
                    // console.log("focus on next item [desktop only]");
                    // console.log(cssSelector);
                    $(cssSelector).focus();
                }, 200);
            }
        };

        var handleTogglingOfHeaderSearchForm = function (ev) {
            ev.preventDefault();
            console.log("toggling search form");

            $(".search-focus-container").toggleClass("has-focus");
            $headerForm.toggleClass("has-focus");
            $(".page").toggleClass("has-overlay");

            setTimeout(function () {
                // focus on next item
                focusOnThis(".header-actions .state-selector > select");
            }, 1000);

            if ($(".search-focus-container").hasClass("has-focus")) {
                setTimeout(function () {
                    // if shown, focus on first field
                    $(".search-focus-container").find("input").focus();
                    // and then wire up an outside click event to close this thang
                    $(".search-focus-container").one("clickoutside focusoutside", handleTogglingOfHeaderSearchForm);
                }, 500);
            } else {
                $(".search-focus-container").off("clickoutside focusoutside", handleTogglingOfHeaderSearchForm);
            }
        };

        var headerFormSubmit = function () {
            var searchVal = $headerForm.find(".search-input").val();
            if (searchVal.trim() === "" && knowledgeCenterUrl) {
                $(this).attr("action", knowledgeCenterUrl);
            }
        };

        /*
        var headerSearchCloseBtnClick = function (ev) {
            ev.preventDefault();
            $headerForm.removeClass("has-focus");
            $(ev.target).closest(".has-focus").removeClass("has-focus");
            $(ev.target).closest(".search-focus-container").find(".search-input, .input-wrapper > input").val("");
            $(ev.target).closest(".search-focus-container").find(".predictive-content ul").html("");
            $(ev.target).closest(".search-focus-container").find(".predictive-content").hide();
            $(".page").removeClass("has-overlay");

            if ($(window).outerWidth() > 992) {
                $headerSearchFocusContainer.fadeOut(200, function () {
                    focusOnThis("#language-switcher");
                });
            }
        };*/

        var headerSearchInputChange = function () {
            var predictiveContent = $(".search .predictive-content");
            var lastSearchTerm = $(".search .predictive-content .last-search-term");
            var noTypeAheadResults = $(".search .predictive-content .no-typeahead-results").html();
            var presetContent = $(".search .preset-content");
            var predictiveResultsUl = predictiveContent.find("ul");
            var searchTermFieldName = $(this).attr("name");
            var searchTerm = $(this).val().trim();
            var searchTermLen = searchTerm.length;

            if (lastSearchTerm.text() !== searchTerm) {
                var searchPage = $headerForm.closest("form").attr("action");
                var searchQuery = "/api/SiteSearch/Results" + "?" + searchTermFieldName + "=" + encodeURIComponent(searchTerm);

                predictiveContent.find("a.view-all").attr("href", searchPage + "?" + searchTermFieldName + "=" + encodeURIComponent(searchTerm));
                if (searchTermLen >= minSearchLength) {
                    predictiveContent.find("a.view-all").show();
                    if ($(this).val()) {
                        predictiveContent.show();
                        presetContent.hide();
                        typeAheadSearch(searchQuery, predictiveResultsUl);
                        currentSearchTerm = searchTerm;
                    } else {
                        predictiveContent.hide();
                        presetContent.show();
                    }
                } else {
                    predictiveContent.find("a.view-all").hide();
                    predictiveResultsUl.empty().append("<li>" + noTypeAheadResults + "</li>");
                    if (searchTermLen === 0) {
                        predictiveContent.hide();
                        presetContent.show();
                    }
                }
                lastSearchTerm.text(searchTerm);
            }
        };

        function typeAheadSearch(searchQuery, ulToFill) {
            $.getJSON(searchQuery).done(function (data) {
                ulToFill.empty();
                $.each(data, function (index, item) {
                    var link = $("<a>").attr("href", item.pageUrl).addClass("typeahead-gtm-trigger").data("gtm-label", item.cleanText).html(item.text);

                    if (item.css) {
                        link.addClass(item.css);
                    }

                    ulToFill.append($("<li>").append(link));
                });
            });
        }

        $headerForm.on("submit", headerFormSubmit);

        $(".global-navigation .search-btn:not(.pharmacy-search)").on("click", handleTogglingOfHeaderSearchForm);

        $headerSearchInput.bind("keyup change", headerSearchInputChange);
        $headerSearchCloseBtn.on("click", handleTogglingOfHeaderSearchForm);

        var $memberSearchInput = $(".is-member-portal form.search .search-input-focus");
        $memberSearchInput.on("focus", handleTogglingOfHeaderSearchForm);

        if (loadedQuerystring["focuswatch"]) {
            document.addEventListener("focusin", function (e) {
                console.log($(e.target).attr("class"));
            });
        }
    };

    var areFiltersActive = function (queryString) {
        // return true/false based on provided queryString; if queryString
        // empty return true/false based on form field values

        queryString = queryString ? $querystring.parse(queryString) : null;

        var isTopic = queryString ? queryString["Topic"] != null && queryString["Topic"] !== "" : $("#filterTopics").val() !== "";
        var isType = queryString ? queryString["TypeFormat"] != null && queryString["TypeFormat"].toString() !== "" : $("#filterTypeFormat").val() !== "";
        var isLocation = queryString ? queryString["Location"] != null && queryString["Location"].toString() !== "" : $("#filterLocation").val();
        var isPlan = queryString ? queryString["Plan"] != null && queryString["Plan"].toString() !== "" : $("#filterPlan").val();
        var isAudience = queryString ? queryString["Audience"] != null && queryString["Audience"].toString() !== "" : $("input[name=Audience]").val();

        return isTopic || isType || isLocation || isPlan || isAudience;
    };

    var heroFormInit = function () {
        // no need to init here unless the search hero is present
        if (!window.scan || !window.scan.siteSearch || !window.scan.siteSearch.searchHero) {
            return;
        }

        $("a[href^='#filterCollapse']").click(function () {
            // if the filters WERE collapsed (and they WILL be open)
            if ($(this).attr("aria-expanded") === "false") {
                $("input[name=Expanded]").val("True");
            } else {
                $("input[name=Expanded]").val("False");
            }
        });

        var $heroSearchInput = $heroForm.find("#knowledgeCenterSearch");
        var $heroSearchFocusContainer = $heroForm.find(".predictive-content");
        var $heroSearchFocusResultsContainer = $heroSearchFocusContainer.find("ul:first");
        var $heroSearchViewAllLink = $heroSearchFocusContainer.find(".view-all");

        var heroFormAction = $heroForm.attr("action");
        var heroFormFieldName = $heroSearchInput.attr("name");
        var heroSearchLastSearchTerm = "";
        var heroSearchNoResultsTemplate = $heroSearchFocusResultsContainer.find("li.no-results-template").removeClass("no-results-template").remove().show().prop("outerHTML");
        var heroFormFocusIn = function () {
            $heroForm.addClass("has-focus");

            if ($heroSearchInput.val().trim().length >= minSearchLength) {
                $heroSearchFocusContainer.fadeIn(200);
            }
        };
        var keyupHandler = function (event) {
            if (event.key === "Escape" || event.key === "Esc") {
                $heroForm.removeClass("has-focus");
                $heroSearchFocusContainer.fadeOut(200);
            }
        };
        var setFormActionAndSubmit = function () {
            if ($heroForm.attr("action").indexOf(searchFilterId) < 0) {
                $heroForm.attr("action", $heroForm.attr("action") + searchFilterId);
            }
            $heroForm.submit();
        };
        var heroSearchInputChange = function () {
            var searchTerm = $heroSearchInput.val().trim();
            var doShow = arguments[0] !== "noShow";

            if (heroSearchLastSearchTerm === searchTerm) {
                return;
            }

            var searchTermIsMinLength = searchTerm.length >= minSearchLength;
            var searchQueryApi = "/api/SiteSearch/Results" + "?" + heroFormFieldName + "=" + encodeURIComponent(searchTerm);
            if (isMemberPortal) {
                searchQueryApi += "&IsMemberPortalSearch=true";
            }
            var searchQueryPage = searchPageUrl + "?" + heroFormFieldName + "=" + encodeURIComponent(searchTerm);
            var fetchedTypeAheadResults = function (results) {
                $heroSearchFocusResultsContainer.empty();
                $heroSearchViewAllLink.toggle(results.length >= 5);
                $heroSearchViewAllLink.attr("href", searchQueryPage);

                if (results.length > 0) {
                    $.each(results, function (idx, resultItem) {
                        var $li = $("<li>");
                        var $a = $("<a>")
                            .data("clean-text", resultItem["cleanText"])
                            .attr("href", resultItem["pageUrl"])
                            .addClass(resultItem["css"] || "")
                            .html("<span>" + resultItem["text"] + "</span>");
                        $li.append($a);
                        $heroSearchFocusResultsContainer.append($li);
                    });
                } else {
                    var searchSource = "notPortal";
                    if (isMemberPortal) {
                        searchSource = "portal";
                    }
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "searchFail",
                        keyphrase: searchTerm,
                        searchLocation: searchSource
                    });
                    $heroSearchFocusResultsContainer.append(heroSearchNoResultsTemplate);
                }
            };
            var formFields = $heroForm.find(":input[name]").not("[name=Term],[name=Audience]");
            var formFieldsAudiencesVal = $heroForm.find("[name=Audience]").val();
            var formFieldsAudiences = formFieldsAudiencesVal ? formFieldsAudiencesVal.split("|") : [];

            $heroSearchViewAllLink.attr("href", heroFormAction + "?" + heroFormFieldName + "=" + encodeURIComponent(searchTerm));
            $heroSearchFocusContainer.toggle(searchTermIsMinLength && doShow);
            heroSearchLastSearchTerm = searchTerm;

            if (!isKnowledgeCenter) {
                $.each(formFields, function (i, formField) {
                    var $field = $(formField);
                    var append = "&" + $field.attr("name") + "=" + $field.val();

                    if ($field.val()) {
                        searchQueryApi += append;
                        searchQueryPage += append;
                    }
                });
                $.each(formFieldsAudiences, function (i, formFieldAudience) {
                    var append = "&Audience=" + formFieldAudience;

                    searchQueryApi += append;
                    searchQueryPage += append;
                });
            }

            if (searchTermIsMinLength) {
                $.getJSON(searchQueryApi).done(fetchedTypeAheadResults);
            }
        };
        var typeaheadResultClick = function (e) {
            e.preventDefault();

            var $this = $(this);

            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                eventCategory: "Search Type Ahead",
                eventAction: $heroSearchInput.val(),
                eventLabel: $this.data("clean-text")
            });

            location.href = this.href;

            return false;
        };

        $("#filterTopics").on("change", setFormActionAndSubmit);
        $("#filterTypeFormat").on("change", setFormActionAndSubmit);
        $("#filterLocation").on("change", setFormActionAndSubmit);
        $("#filterPlan").on("change", setFormActionAndSubmit);
        $heroForm.attr("action", searchPageUrl);
        $heroForm.on("keyup", keyupHandler);
        $heroSearchInput.on("focusin", heroFormFocusIn);
        $heroSearchInput.on("keyup change", heroSearchInputChange);

        $heroForm.on("click", "div.predictive-content ul li a", typeaheadResultClick);

        $heroSearchFocusContainer.on("click", ".close-btn", function () {
            $heroSearchFocusContainer.hide();
        });

        $("#sortselect").change(function () {
            var option = $(this).find("option:selected");
            window.location.href = option.data("url");
        });

        if (loadedSearchTerm) {
            // page loaded with a search term - preload the results but
            // don't show the type-ahead ui
            heroSearchInputChange("noShow");
        }
        $audienceButtons.on("click", searchAudienceButtonClicked);
    };

    function init() {
        headerFormInit();
        heroFormInit();
    }

    function clearSearchFiltersBtn() {
        // attach event handler to the clear button in the filter form and the
        // clear link in the search results
        var $clearFilterBtn = $(".search-filters .clear-filters,.search-results-container a.clear");
        var $searchFilters = $(".search-filters .bselect");

        if ($clearFilterBtn.length > 0) {
            // on search filter change ...
            $searchFilters.on("changed.bs.select", function (event, clickedIndex) {
                if (clickedIndex > 0) {
                    $clearFilterBtn.show();
                }
                var getSelectedIndex = $searchFilters
                    .map(function () {
                        return $(this)[0].selectedIndex;
                    })
                    .get();

                var sumSelectedIndex = getSelectedIndex.reduce(function (a, b) {
                    return parseInt(a) + parseInt(b);
                });

                if (sumSelectedIndex === 0) {
                    $clearFilterBtn.hide();
                }
            });

            // On click of the clear filter button/link ...
            $clearFilterBtn.on("click", function (e) {
                var isLink = this.tagName === "A";

                $audienceButtons.each(function (index, item) {
                    $(item).attr("aria-selected", "");
                });
                // this sets the form field value for audience
                searchAudienceButtonClicked();

                $searchFilters.each(function () {
                    if ($(this)[0].selectedIndex > 0) {
                        // If search filters selectedIndex > 0 ...
                        // $searchFilters.selectpicker("deselectAll"); // seems to not work
                        $(this).val("");
                        $(this).selectpicker("refresh");

                        $("input[name=Audience]").val("");

                        $clearFilterBtn.hide();
                    }
                });

                $heroForm.attr("action", searchPageUrl);

                if (isLink) {
                    // triggered from a link, which does not submit the form
                    $heroForm.submit();

                    // prevent execution of the link which will
                    return false;
                }
            });
        }

        if (areFiltersActive()) {
            $clearFilterBtn.show();
        }

        $(document).on("click", ".typeahead-gtm-trigger", function () {
            var link = $(this);

            var dataLayer = window.dataLayer || [];
            dataLayer.push({
                eventCategory: "Search Type Ahead",
                eventAction: currentSearchTerm,
                eventLabel: link.data("gtm-label")
            });
        });
    }

    init();
    clearSearchFiltersBtn();
});
